<template>
  <span
    class="tw-inline-flex tw-aspect-[1/1] tw-h-[18px] tw-w-[18px] tw-items-center tw-justify-center tw-leading-none xs2:tw-h-[16px] xs2:tw-w-[16px] md:tw-h-[18px] md:tw-w-[18px]"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      class="tw-h-full tw-w-full"
      aria-hidden="true"
    >
      <path
        d="M5.0625 13.5V15.1875"
        stroke="currentColor"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.9375 13.5V15.1875"
        stroke="currentColor"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0625 6.75H9.5625V10.125H14.0625V6.75Z"
        stroke="currentColor"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0625 7.3125H16.875V10.125C16.875 11.0201 16.5194 11.8786 15.8865 12.5115C15.2536 13.1444 14.3951 13.5 13.5 13.5H4.5C3.60489 13.5 2.74645 13.1444 2.11351 12.5115C1.48058 11.8786 1.125 11.0201 1.125 10.125V7.3125H9.5625"
        stroke="currentColor"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.9375 7.3125V3.65625C3.9375 3.28329 4.08566 2.92561 4.34938 2.66189C4.6131 2.39816 4.97079 2.25 5.34375 2.25C5.67125 2.24923 5.9892 2.36034 6.24493 2.56493C6.50067 2.76952 6.67886 3.05532 6.75 3.375"
        stroke="currentColor"
        stroke-width="1.125"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>
</template>
<script>
export default {
  name: 'Bathtub',
};
</script>
